import { useMemo } from "react";
import { Col, Row } from "antd";
import CumulativeFilters from "./Filters";
import CumulativeOverview from "./Overview";
import SpeedMap from "./SpeedMap";
import SpeedAnalytics from "./Analytics/Speed";
import BatteryPerformance from "./Analytics/Battery";
import BrakeAnalytics from "./Analytics/Brake";
import { getGrafanaBaseURL, 
  getGrafanaInterval,
  grafanaDynamicSampling } from "../../Common/Utils";
import { TEST_RIDE_CUMULATIVE } from "../../Common/Grafana/Constants";

const SingleSummary = ({
  data,
  modelList,
  summaryList,
  tripSummary,
  updateSummaryList,
  updateTripSummary,
}) => {
  const currentTripSummary = tripSummary?.[data];

  const baseFilterObject = useMemo(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    return {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      interval: getGrafanaInterval(
        currentTripSummary?.startTime,
        currentTripSummary?.stopTime
      ),
      from: currentTripSummary?.startTime,
      to: currentTripSummary?.stopTime,
      trip_ids: currentTripSummary?.tripIds?.join(","),
    }

    // eslint-disable-next-line
  }, [currentTripSummary?.startTime, currentTripSummary?.stopTime, currentTripSummary?.tripIds]);

  const grafanaMotorFilterObject = useMemo(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    return {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      interval: grafanaDynamicSampling(
        currentTripSummary?.startTime,
        currentTripSummary?.stopTime,
        'motor',
        60,
        currentTripSummary?.tripIds?.length
      ),
      from: currentTripSummary?.startTime,
      to: currentTripSummary?.stopTime,
      trip_ids: currentTripSummary?.tripIds?.join(","),
    }

    // eslint-disable-next-line
  }, [currentTripSummary?.startTime, currentTripSummary?.stopTime, currentTripSummary?.tripIds]);

  const grafanaBatteryFilterObject = useMemo(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    return {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      interval: grafanaDynamicSampling(
        currentTripSummary?.startTime,
        currentTripSummary?.stopTime,
        'battery',
        60,
        currentTripSummary?.tripIds?.length
      ),
      from: currentTripSummary?.startTime,
      to: currentTripSummary?.stopTime,
      trip_ids: currentTripSummary?.tripIds?.join(","),
    }

    // eslint-disable-next-line
  }, [currentTripSummary?.startTime, currentTripSummary?.stopTime, currentTripSummary?.tripIds]);


  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <CumulativeFilters
            data={data}
            modelList={modelList}
            summaryList={summaryList}
            tripSummary={tripSummary}
            updateSummaryList={updateSummaryList}
            updateTripSummary={updateTripSummary}
          />
        </Col>
      </Row>
      {currentTripSummary ? (
        <Row>
          <Col span={24}>
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <CumulativeOverview
                  summaryList={summaryList}
                  tripSummary={currentTripSummary}
                />
                <SpeedMap
                  summaryList={summaryList}
                  tripSummary={currentTripSummary}
                />
              </Col>
            </Row>
            <Row gutter={[16, 16]} className="mt1">
              <Col span={24}>
                <SpeedAnalytics
                  summaryList={summaryList}
                  tripSummary={currentTripSummary}
                  baseUrl={getGrafanaBaseURL(
                    TEST_RIDE_CUMULATIVE.DASHBOARD_ID,
                    TEST_RIDE_CUMULATIVE.DASHBOARD_NAME
                  )}
                  baseFilterObject={grafanaMotorFilterObject}
                  data={data}
                />
              </Col>
              <Col span={24}>
                <BatteryPerformance
                  summaryList={summaryList}
                  tripSummary={currentTripSummary}
                  baseUrl={getGrafanaBaseURL(
                    TEST_RIDE_CUMULATIVE.DASHBOARD_ID,
                    TEST_RIDE_CUMULATIVE.DASHBOARD_NAME
                  )}
                  baseFilterObject={grafanaBatteryFilterObject}
                  data={data}
                />
              </Col>
              <Col span={24}>
                <BrakeAnalytics
                  summaryList={summaryList}
                  tripSummary={currentTripSummary}
                  baseUrl={getGrafanaBaseURL(
                    TEST_RIDE_CUMULATIVE.DASHBOARD_ID,
                    TEST_RIDE_CUMULATIVE.DASHBOARD_NAME
                  )}
                  baseFilterObject={baseFilterObject}
                  data={data}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      ) : null}
    </>
  );
};

export default SingleSummary;
